import React from "react";
import { InfiniteScroll, Button } from "nq-component";
import BaseListPage from "../../../../../base/BaseListPage";

import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";

import Table from "../../../../../components/Table";
import ViewTraineesPresenter from "./ViewTraineesPresenter";
import Progress from "../../../../../components/Progress";

export default class ViewTrainees extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ViewTraineesPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      object: {},
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  getCollectionName() {
    return "attendees";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  queryObject() {
    return this.props.object;
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, count, current, limit, loading } = this.state;

    const includeLabel = Object.keys(schema.fields).filter(
      (fields) => fields !== "training" && fields !== "stats"
    );

    if (!schema) return <Progress />;

    return (
      <>
        <div className="overflow-auto">
          <div className="mt-4">
            <InfiniteScroll loadMore={this.loadMore.bind(this)}>
              <Table
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At", ...includeLabel]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </InfiniteScroll>
          </div>
        </div>
      </>
    );
  }
}
